<!-- A grid, not a flex row: the heading and its badge sit in their own track so the dialog surface can
	 centre them on the dialog's axis while the close control keeps the inline-end edge (see SCSS). -->
<header class="shrink-0 eff-clarity-dialog-frame__header">
	<div vertical="center" class="gap-sm eff-clarity-dialog-frame__title">
		<!-- Two branches rather than `role="heading"`: a native element is the level every AT reads
			 without an ARIA fallback. Both carry the same classes and test id. -->
		@if (headingLevel() === 1) {
			<h1
				#headingElement
				#headingTooltip="matTooltip"
				class="min-w-0 eff-clarity-dialog-frame__heading"
				[class.text-center]="headingAlign() === 'center'"
				[class.line-clamp-2]="clampHeading() && !truncateHeading()"
				[class.truncate]="truncateHeading()"
				[class.max-w-full]="truncateHeading()"
				[matTooltip]="heading()"
				dsTestId="clarity-dialog-frame-heading"
				(mouseenter)="onHeadingEnter(headingElement, headingTooltip)"
			>
				{{ heading() }}
			</h1>
		} @else {
			<h2
				#headingElement
				#headingTooltip="matTooltip"
				class="min-w-0 eff-clarity-dialog-frame__heading"
				[class.text-center]="headingAlign() === 'center'"
				[class.line-clamp-2]="clampHeading() && !truncateHeading()"
				[class.truncate]="truncateHeading()"
				[class.max-w-full]="truncateHeading()"
				[matTooltip]="heading()"
				dsTestId="clarity-dialog-frame-heading"
				(mouseenter)="onHeadingEnter(headingElement, headingTooltip)"
			>
				{{ heading() }}
			</h2>
		}

		@if (count() !== undefined) {
			<eff-badge shape="count" size="sm" dsTestId="clarity-dialog-frame-count">{{ count() }}</eff-badge>
		}
	</div>

	@if (closable()) {
		<eff-icon-button
			variant="ghost"
			size="md"
			icon="close"
			class="eff-clarity-dialog-frame__close"
			[ariaLabel]="closeLabel()"
			dsTestId="clarity-dialog-frame-close"
			(clicked)="onClose()"
		/>
	}
</header>

<!--
	`role="alert"` is on the element that renders the message, never on a wrapper: an alert region
	that holds no text announces nothing, and a spec resolving the wrapper would still pass.
-->
@if (error(); as message) {
	<p role="alert" class="eff-clarity-dialog-frame__error" dsTestId="clarity-dialog-frame-error">{{ message }}</p>
}

<div class="ds-scrollable--y ds-scrollable--compact eff-clarity-dialog-frame__body">
	<ng-content />
</div>

<!--
	The footer slot is unwrapped on purpose. A wrapper element would be in the DOM whether or not the
	consumer projected anything, and `<ng-content>` may not be placed under `@if` — the projected
	content would still be instantiated while hidden. Projecting the region itself means "no footer"
	renders nothing at all; spacing comes from the host column's `gap`.
-->
<ng-content select="[data-slot='footer']" />
